import {
  LOADING_ON,
  LOADING_OFF,
  SET_HOME_PACKAGES,
  SET_STATISTICS,
  SET_USER,
  SET_USER_LOGGED_IN,
  LOG_OUT,
  SET_USER_PHOTO,
  SET_PROFILE,
} from "./../types";
import api from "../../const/axios";
import { clearToken, getLiveToken, setToken } from "../../const/auth";

export const loadingOn = () => ({ type: LOADING_ON });
export const loadingOff = () => ({ type: LOADING_OFF });

export const getHomePackages = () => async (dispatch) => {
  dispatch({
    type: LOADING_ON,
  });
  await api.get("/packages/forhome").then((res) => {
    dispatch({
      type: SET_HOME_PACKAGES,
      payload: res.data.packages,
    });
  });
  dispatch({
    type: LOADING_OFF,
  });
};

export const setPackages = (data) => {
  return {
    type: SET_HOME_PACKAGES,
    payload: data,
  };
};

export const getStatistics = () => async (dispatch) => {
  dispatch({
    type: LOADING_ON,
  });
  await api.get("/info/stats").then((res) => {
    dispatch({
      type: SET_STATISTICS,
      payload: res.data,
    });
  });
  dispatch({
    type: LOADING_OFF,
  });
};

export const setUserPhoto = (data) => {
  return {
    type: SET_USER_PHOTO,
    payload: data,
  };
};

/**
 * Restores or refreshes the session: the server validates the bearer and answers with
 * the current profile and a freshly issued token (sliding session).
 */
export const logUserIn = (showLoader = false) => async (dispatch) => {
  const token = getLiveToken();
  if (!token) {
    dispatch(logOut());
    return;
  }
  if (showLoader) dispatch({ type: LOADING_ON });
  try {
    const res = await api.get(`users/current`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setToken(res.data.token);
    dispatch({
      type: SET_USER_LOGGED_IN,
      payload: res.data,
    });
  } catch (er) {
    // Only a rejected session ends it; a network blip keeps the user signed in.
    const status = er?.response?.status;
    if (status === 401 || status === 403) dispatch(logOut());
  } finally {
    if (showLoader) dispatch({ type: LOADING_OFF });
  }
};

/** Stores a token returned by login/Google sign-in and marks the user as signed in. */
export const signedIn = (data) => (dispatch) => {
  setToken(data.token);
  dispatch({
    type: SET_USER,
    payload: { data },
  });
};

export const logOut = () => (dispatch) => {
  clearToken();
  dispatch({
    type: LOG_OUT,
  });
};

export const setProfile = (payload) => {
  return {
    type: SET_PROFILE,
    payload,
  };
};

// Renders inline (state.profile.loading) rather than through the full-screen loader, and
// always settles so a failed request can't leave the page loading forever.
export const getProfile = (type, id) => async (dispatch, getState) => {
  // Refreshing the profile already on screen (after creating a team, accepting an invite…)
  // stays silent; only switching to another profile shows the skeleton.
  const current = getState().profile;
  const sameProfile = !current.error && !current.loading && current.id !== undefined &&
    (type ? current.own === true : !current.own && String(current.id) === String(id));
  if (!sameProfile) {
    dispatch({
      type: SET_PROFILE,
      payload: { loading: true, error: false },
    });
  }
  try {
    const res = await api.get(type ? "users/profile" : `users/profile?id=${encodeURIComponent(id)}`);
    dispatch({
      type: SET_PROFILE,
      payload: { ...res.data, own: !!type, loading: false, error: false },
    });
  } catch {
    dispatch({
      type: SET_PROFILE,
      payload: { loading: false, error: true },
    });
  }
};
